import { c as _c } from "react/compiler-runtime";
import { chakra } from '@chakra-ui/react';
import { RenderLeafProps } from 'slate-react';
export const UnderlineLeaf = props => {
  const $ = _c(3);
  const t0 = props.children || props.text;
  let t1;
  if ($[0] !== props.attributes || $[1] !== t0) {
    t1 = <chakra.u {...props.attributes}>{t0}</chakra.u>;
    $[0] = props.attributes;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};